// @flow

import * as React from 'react';

import { NotFound } from 'gandi.react-static-pages';

import { Layout } from './Layout';

export default (): React.Node => (
  <Layout>
    <NotFound />
  </Layout>
);
